import { Modal, ModalProps } from 'antd';
import styled from '@emotion/styled';
const Desc = styled.div`
  line-height: 1.2;
  margin-bottom: 12px;
`;

export interface OpenModalOfContentProps extends ModalProps {
  content: React.ReactNode;
  subTitle?: React.ReactNode;
  desc?: React.ReactNode;
}

const OpenModalOfContent = ({
  content,
  subTitle,
  title,
  desc,
  ...otherProps
}: OpenModalOfContentProps) => {
  return (
    <Modal footer={false} width={416} title={subTitle} {...otherProps}>
      <div>
        {desc && <Desc>{desc}</Desc>}
        {content}
      </div>
    </Modal>
  );
};

export default OpenModalOfContent;
